import { withAuthenticationRequired } from "@auth0/auth0-react";
import { FC, useMemo } from "react";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

export const AuthenticationGuard = ({ component }: { component: FC }) => {
  const Component = useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => <FullScreenLoader />,
      }),
    [component],
  );

  return <Component />;
};
